const m = require('minthril');
const { component } = require('../../component');

const ErrorToast = component(() => ({
  view: ({ attrs: { message, onDismiss } }) => m('aside.error-toast', {
    role: 'alert'
  }, [
    m('p', message),
    m('button.error-toast__dismiss', {
      type: 'button',
      'aria-label': 'Dismiss error',
      onclick: onDismiss
    }, '×')
  ])
}));

module.exports = { ErrorToast };
